import React, { useState } from 'react'
import { object } from 'prop-types'
import IssueMagazineViewer from '@/component/Primitive/IssueMagazineViewer'

const mapImageProps = (items) =>
  items.map((item) => ({
    ...item,
    imageUrl: item.images?.main_141x106_141[0]?.url
  }))

const MagazineIssueViewerWidget = ({ pageData, instance }) => {
  const { magazineIssue, params, isDesktop } = pageData
  const [currentPage, setCurrentPage] = useState(params.page || '0')

  const onHighlightClick = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const highlights =
    magazineIssue?.highlights && mapImageProps(magazineIssue.highlights)

  const issuPublicationId =
    magazineIssue.issuPublicationIdOverride || instance.issuPublicationId

  return (
    <div>
      <IssueMagazineViewer
        page={currentPage}
        issuPublicationId={issuPublicationId}
        issuIssueId={magazineIssue.issuIssueId}
        highlights={highlights.slice(0, 4)}
        onHighlightClick={onHighlightClick}
        magazineOrigin={magazineIssue.magazineOrigin}
        isDesktop={isDesktop}
      />
    </div>
  )
}

MagazineIssueViewerWidget.propTypes = {
  pageData: object,
  instance: object
}

export default MagazineIssueViewerWidget
